import React, { useState } from "react";
import { DataGrid } from "@mui/x-data-grid";
import { useDispatch, useSelector } from "react-redux";
import {
  customerSelector,
  getAllCustomers,
} from "../store/slices/customerSlice";
import _ from "lodash";
import { useEffect } from "react";
import { userSelector } from "src/store/slices/userSlice";
import { Grid, Typography } from "@mui/material";
import { emailStatus } from "src/constants";

const columns = [
  {
    field: "dateAdded",
    headerName: "Date added",
    type: "string",
    width: 130,
  },
  {
    field: "id",
    headerName: "ID",
    type: "string",
    width: 220,
  },
  {
    field: "firstName",
    headerName: "First name",
    width: 150,
  },
  {
    field: "lastName",
    headerName: "Last name",
    width: 150,
  },
  {
    field: "email",
    headerName: "Email",
    width: 150,
  },
  {
    field: "phoneNumber",
    headerName: "Phone number",
    width: 150,
  },
  {
    field: "address",
    headerName: "Address",
    width: 350,
  },
  {
    field: "entityName",
    headerName: "Entity",
    width: 150,
  },
];

export default function CustomerList() {
  const dispatch = useDispatch();
  const user = useSelector(userSelector);
  const customers = useSelector(customerSelector);

  const [rows, setRows] = useState([]);

  function handleGetAllCustomers(userId) {
    dispatch(getAllCustomers(userId));
  }

  useEffect(() => {
    if (user) handleGetAllCustomers(user);
  }, [user]);

  useEffect(() => {
    setRows(
      customers?.docs?.map((doc) => {
        const isCurrent = emailStatus.CURRENT;
        const currentAddress = doc.addresses?.find(
          (email) => email.status === isCurrent
        )?.fullAddress;
        const currentEmail = doc.emails?.find(
          (email) => email.status === isCurrent
        )?.address;
        const currentPhoneNumber = doc.phoneNumbers?.find(
          (email) => email.status === isCurrent
        )?.number;

        const date = new Date(doc.createdAt);
        return {
          id: doc._id,
          entity: doc?.entities?.map((entity) => entity?.entityName) || "N/A",
          firstName: doc.firstName,
          lastName: doc.lastName,
          address: currentAddress,
          email: currentEmail,
          phoneNumber: currentPhoneNumber,
          dateAdded: `${date.getDate()}.${
            date.getMonth() + 1
          }.${date.getFullYear()}`,
        };
      })
    );
  }, [customers]);

  return (
    <Grid
      container
      item
      direction="column"
      spacing={2}
      style={{ marginTop: "64px", padding: "20px" }}
    >
      <Grid item>
        <Typography
          variant="h1"
          style={{ fontSize: "32px", fontWeight: 800, letterSpacing: "-1.5px" }}
        >
          Customers
        </Typography>
      </Grid>
      <Grid item style={{ height: "66vh" }}>
        <DataGrid
          onCellClick={(params, event) => {
            event.defaultMuiPrevented = true;
          }}
          rows={rows || []}
          columns={columns}
          pageSize={10}
          rowsPerPageOptions={[10]}
          disableSelectionOnClick
          style={{ background: "#ffffff" }}
        />
      </Grid>
    </Grid>
  );
}
